export enum OrganisationId {
  FINPACK = 1,
  MORIZON = 2,
  FINANSET = 3,
  ADEF = 4,
  MACHOWSCY = 5,
  AVIVA = 6,
  ALEX_T_GREAT = 7,
  EMMERSON = 8,
  EXPANDER = 9,
  PHINANCE = 10,
  M_FINANSE = 11,
  NOTUS = 12,
  DR_FINANCE = 13,
  OPEN_FINANCE = 14,
  METRO_HOUSE = 15,
  DOM_DEVELOPMENT = 16,
  GOLD_FINANCE = 17,
  LENDI = 18,
  ANG_SPOLDZIELNIA = 19,
  FINAMAX = 20,
  SPRAWDZONY_EKSPERT = 21,
  FENIKS_FINANSE = 22,
  BANCOVO = 25,
  HOME_ESTATE = 26,
  ING = 27,
  LOANDO = 28,
  RANKOMAT = 29,
  MILLENNIUM = 30,
  HIPORANKER = 31,
  DSA = 32,
  PORADNIK_KREDYTOWY = 33,
  LEADGURU = 34,
}
